__turbopack_context__.v({
  "actions": "AddUser-module__FUIyba__actions",
  "container": "AddUser-module__FUIyba__container",
  "createdName": "AddUser-module__FUIyba__createdName",
  "inviteQuestion": "AddUser-module__FUIyba__inviteQuestion",
  "row": "AddUser-module__FUIyba__row",
  "section": "AddUser-module__FUIyba__section",
  "sentEmail": "AddUser-module__FUIyba__sentEmail",
  "sentState": "AddUser-module__FUIyba__sentState",
  "sentText": "AddUser-module__FUIyba__sentText",
  "toggle": "AddUser-module__FUIyba__toggle",
  "toggleCheckbox": "AddUser-module__FUIyba__toggleCheckbox",
  "toggleLabel": "AddUser-module__FUIyba__toggleLabel",
  "toggleSwitch": "AddUser-module__FUIyba__toggleSwitch",
});
